import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LoadingSkeletonComponent } from '@shared/components/loading-skeleton';
import { LoadingSkeletonBaseClass } from '@shared/components/loading-skeleton-base-class';

@Component({
  selector: 'app-site-at-a-glance-loading-skeleton',
  imports: [LoadingSkeletonComponent],
  templateUrl: './site-at-a-glance-loading-skeleton.component.html',
  host: {
    class: 'block',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteAtAGlanceLoadingSkeletonComponent extends LoadingSkeletonBaseClass {}
